export const PRIMARY_COLOR_TEXT = {
    id: 'oe.color.primary',
    description: 'Label text',
    defaultMessage: 'Primary Color',
};

export const HEX_OR_RGB_TEXT = {
    id: 'oe.color.HEXOrRGB',
    description: 'Button text',
    defaultMessage: 'Enter a HEX or RGB Code',
};

export const CONFIGURE_SCHEDULED_EMAILS_TEXT = {
    id: `oe.websiteTab.configureScheduledEmails`,
    description: 'title text',
    defaultMessage: 'Configure Scheduled Emails',
};

export const CONFIGURE_CUSTOM_CSS_TEXT = {
    id: `oe.websiteTab.configureCustomCss`,
    description: 'title text',
    defaultMessage: 'Configure Custom CSS'
};

export const CONFIGURE_NAVIGATION_TEXT = {
    id: 'oe.websiteTab.configureNavigation',
    description: 'title text',
    defaultMessage: 'Configure Navigation',
};

export const CONFIGURE_SIGN_IN_TEXT = {
    id: 'oe.websiteTab.configureSignIn',
    description: 'title text',
    defaultMessage: 'Configure Sign In',
};

export const CONFIGURE_PASSPORT_SETTINGS_TEXT = {
    id: 'oe.websiteTab.configurePassportSettings',
    description: 'title text',
    defaultMessage: 'Configure Passport Settings',
};

export const CONFIGURE_RESPONSIVE_EMAILS_TEXT = {
    id: `oe.websiteTab.configureResponsiveEmails`,
    description: 'title text',
    defaultMessage: 'Configure Responsive Emails',
};

export const EMAIL_DISPLAY_NAME_INFO_MESSAGE_TEXT = {
    id: 'oe.passport.emailDisplayNameInfoMessage',
    description: 'Info Message',
    defaultMessage: `
        The ‘From’ email address for all emails will be no-reply@openexc.com.
        The Display Name will be the name of the email sender; this will appear in the recipient’s
        inbox as the name of the email sender.  The email address will also still be visible to the
        recipient.  If no Display Name is entered, only the email address will appear to the recipient.
    `
};

export const NO_SELECTED_URL_TEXT = {
    id: 'oe.passport.noSelectedURL',
    description: 'warning message text',
    defaultMessage: 'You have not selected a URL for Passport yet.',
};

export const PASSPORT_SETTINGS_TEXT = {
    id: 'oe.passport.passportSettings',
    defaultMessage: 'Passport Settings',
    description: 'Label text',
};

export const RESTRICTED_PASSPORT_SETTINGS_TEXT = {
    id: 'oe.passport.restrictedPassportSettings',
    defaultMessage: 'Event Title & Description',
    description: 'Label text',
};

export const PASSPORT_SETTINGS_FIELDS_TEXT = {
    id: 'oe.passport.passportSettingsFields',
    defaultMessage:
        'URL, Theme, Event Title, Event Public Description, Event Private Description' +
        ', Sign In Settings, Privacy Policy Settings, Access Code Settings, Calendar Invite, Logo Image, Background Image, Primary Color',
    description: 'Button text',
};

export const RESTRICTED_PASSPORT_SETTINGS_FIELDS_TEXT = {
    id: 'oe.passport.restrictedPassportSettingsFields',
    defaultMessage: 'Event Title, Event Public Description, Event Private Description',
    description: 'Button text',
};

export const PAGES_IN_TOP_NAVIGATION_SIGN_IN_REQUIRED_TEXT = {
    id: 'oe.website.pagesInTopNavigationSignInRequired',
    description: 'Label text',
    defaultMessage: 'PAGES IN TOP NAVIGATION (Sign-In Required)',
};

export const WEBSITE_CONFIGURE_TEXT = {
    id: 'oe.website.configure',
    defaultMessage: 'Configure',
    description: 'Button text',
};

export const PAGES_IN_TOP_NAVIGATION_PUBLIC_TEXT = {
    id: 'oe.website.pagesInTopNavigationPublic',
    description: 'Label text',
    defaultMessage: 'PAGES IN TOP NAVIGATION (Public)',
};

export const MEETING_DETAILS_PAGE_TEXT = {
    id: 'oe.passport.meetingDetailsPage',
    defaultMessage: 'Meeting Details Page',
    description: 'Label text',
};

export const LABEL_FOR_MEETING_LINKS_SECTION_TEXT = {
    id: 'oe.passport.labelForMeetingLinksSection',
    description: 'Label for Meeting Links section title',
    defaultMessage: 'Label for Meeting Links section',
};

export const ENTER_LABEL_FOR_MEETING_LINKS_SECTION_TEXT = {
    id: 'oe.website.enterLabelForMeetingLinksSection',
    defaultMessage: 'Enter a label for Meeting Links section',
    description: 'Placeholder text',
};

export const SAVE_WEBSITE_TEXT = {
    id: 'oe.website.save',
    defaultMessage: 'Save',
    description: 'Button text',
};

export const SAVED_WEBSITE_TEXT = {
    id: 'oe.website.saved',
    defaultMessage: 'Saved',
    description: 'Button text',
};

export const CONFIGURE_REGISTRATION_FORM_TEXT = {
    id: 'oe.passport.configureRegistrationForm',
    defaultMessage: 'Configure Registration Form',
    description: 'Button text',
};

export const PASSPORT_EMAILS_TEXT = {
    id: 'oe.passport.emails',
    defaultMessage: 'emails',
    description: 'Label text',
};

export const PASSPORT_RESPONSIVE_EMAILS_TEXT = {
    id: 'oe.passport.responsiveEmails',
    defaultMessage: 'Responsive Emails',
    description: 'Button text',
};

export const EMAIL_DISPLAY_NAME_TEXT = {
    id: 'oe.passport.emailDisplayName',
    description: 'From Email address Display Nam title',
    defaultMessage: 'From Email address Display Name',
};

export const ENTER_DISPLAY_NAME_TEXT = {
    id: 'oe.website.enterDisplayName',
    defaultMessage: 'Enter a display name',
    description: 'Placeholder text',
};

export const SCHEDULED_EMAILS_TEXT = {
    id: 'oe.passport.scheduledEmails',
    defaultMessage: 'Scheduled Emails (Reminders)',
    description: 'Button text',
};

export const CUSTOM_CSS_TEXT = {
    id: 'oe.passport.customCss',
    defaultMessage: 'custom css',
    description: 'Label text'
};

export const CUSTOM_CSS_APPLIED_TEXT = {
    id: 'oe.passport.customCssApplied',
    defaultMessage: 'Custom CSS has been applied',
    description: 'Button text'
};

export const NO_CUSTOM_CSS_APPLIED_TEXT = {
    id: 'oe.passport.noCustomCssApplied',
    defaultMessage: 'No Custom CSS has been applied',
    description: 'Button text'
};

export const CONFIGURE_TITLE_AND_DESCRIPTION_TEXT = {
    id: 'oe.websiteTab.configureTitleAndDescription',
    description: 'title text',
    defaultMessage: 'Configure Title & Description',
};
